/**
 * Service for SMS
 */
import {
  CANCEL_SCHEDULED_SMS,
  CREATE_CHAT_SETTING,
  CREATE_SMS,
  FETCH_CANCELLED_SMS,
  FETCH_CHAT_LIST,
  FETCH_MESSAGES_BY_CHAT_ID,
  FETCH_SCHEDULED_SMS,
  FETCH_SMS_CLICKS,
  FETCH_SMS_STATUSES,
  GET_CHAT_SETTING,
  REPLY_TO_THE_CHAT,
  UPDATE_CHAT_SETTING,
} from '../actions/types/smsTypes';
import { getError } from '../../utils/common/helper';
import { FAILED, getFailed, getStarted, getSucceeded, STARTED, SUCCEEDED } from '../../utils/helpers/store-helpers';

// Initial state
const initialState = {
  errors: null,
  smsList: [],
  scheduledList: [],
  cancelledList: [],
  chats: [],
  chat: [],
  smsCreateStatus: '',
  smsStatusesFetchStatus: '',
  scheduledFetchStatus: '',
  cancelledFetchStatus: '',
  scheduledCancelStatus: '',
  clicks: null,
  clicksFetchStatus: '',
  chatListStatus: '',
  chatFetchStatus: '',
  smsRelyStatus: '',
  chatSettingStatus: '',
  chatSetting: '',
  createChatSettingStatus:'',
  updateChatSettingStatus:''
};

// Client reducer
const events = (state = initialState, { type, payload }) => {
  switch (type) {
    case getStarted(CREATE_SMS):
      return { ...state, smsCreateStatus: STARTED, errors: null };
    case getFailed(CREATE_SMS):
      return { ...state, smsCreateStatus: FAILED, errors: getError(payload) };
    case getSucceeded(CREATE_SMS):
      return { ...state, smsList: state.smsList.concat(payload.createdSmsStatuses), smsCreateStatus: SUCCEEDED, errors: null };
    case getStarted(FETCH_SMS_STATUSES):
      return { ...state, smsStatusesFetchStatus: STARTED, errors: null };
    case getFailed(FETCH_SMS_STATUSES):
      return { ...state, smsStatusesFetchStatus: FAILED, errors: getError(payload) };
    case getSucceeded(FETCH_SMS_STATUSES):
      return { ...state, smsList: payload, smsStatusesFetchStatus: SUCCEEDED, errors: null };

    case getStarted(FETCH_SCHEDULED_SMS):
      return { ...state, scheduledFetchStatus: STARTED, errors: null };
    case getFailed(FETCH_SCHEDULED_SMS):
      return { ...state, scheduledFetchStatus: FAILED, errors: getError(payload) };
    case getSucceeded(FETCH_SCHEDULED_SMS):
      return { ...state, scheduledList: payload, scheduledFetchStatus: SUCCEEDED, errors: null };

    case getStarted(FETCH_CANCELLED_SMS):
      return { ...state, cancelledFetchStatus: STARTED, errors: null };
    case getFailed(FETCH_CANCELLED_SMS):
      return { ...state, cancelledFetchStatus: FAILED, errors: getError(payload) };
    case getSucceeded(FETCH_CANCELLED_SMS):
      return { ...state, cancelledList: payload, cancelledFetchStatus: SUCCEEDED, errors: null };

    case getStarted(FETCH_SMS_CLICKS):
      return { ...state, clicksFetchStatus: STARTED, errors: null };
    case getFailed(FETCH_SMS_CLICKS):
      return { ...state, clicksFetchStatus: FAILED, errors: getError(payload) };
    case getSucceeded(FETCH_SMS_CLICKS):
      return { ...state, clicks: payload, clicksFetchStatus: SUCCEEDED, errors: null };

    case getStarted(CANCEL_SCHEDULED_SMS):
      return { ...state, scheduledCancelStatus: STARTED, errors: null };
    case getFailed(CANCEL_SCHEDULED_SMS):
      return { ...state, scheduledCancelStatus: FAILED, errors: getError(payload) };
    case getSucceeded(CANCEL_SCHEDULED_SMS):
      return {
        ...state,
        scheduledList: state.scheduledList.filter((s) => s.smsId !== payload.smsId),
        scheduledCancelStatus: SUCCEEDED,
        errors: null,
      };

    case getStarted(FETCH_CHAT_LIST):
      return { ...state, chatListStatus: STARTED };
    case getFailed(FETCH_CHAT_LIST):
      return { ...state, chatListStatus: FAILED };
    case getSucceeded(FETCH_CHAT_LIST):
      return { ...state, chats: payload, chatListStatus: SUCCEEDED };

    case getStarted(FETCH_MESSAGES_BY_CHAT_ID):
      return { ...state, chatFetchStatus: STARTED };
    case getFailed(FETCH_MESSAGES_BY_CHAT_ID):
      // Un tableau, pas un objet : le composant fait chatMessages.map(...) et
      // `?? []` ne rattrape pas un objet vide, non nullish. Un échec de
      // chargement faisait donc planter le rendu de la conversation.
      return { ...state, chat: [], chatFetchStatus: FAILED, errors: getError(payload) };
    case getSucceeded(FETCH_MESSAGES_BY_CHAT_ID):
      return { ...state, chat: payload.data, chatFetchStatus: SUCCEEDED };

    case getStarted(REPLY_TO_THE_CHAT):
      return { ...state, smsRelyStatus: STARTED, errors: null };
    case getFailed(REPLY_TO_THE_CHAT):
      return { ...state, smsRelyStatus: FAILED, errors: getError(payload) };
    case getSucceeded(REPLY_TO_THE_CHAT):
      return { ...state, chat: state.chat.concat(payload), smsRelyStatus: SUCCEEDED, errors: null }; // concat only payload


    case getStarted(CREATE_CHAT_SETTING):
      return { ...state, createChatSettingStatus: STARTED, errors: null };
    case getFailed(CREATE_CHAT_SETTING):
      return { ...state, createChatSettingStatus: FAILED, errors: getError(payload) };
    case getSucceeded(CREATE_CHAT_SETTING):
      return { ...state, chatSetting: state.chat.concat(payload), createChatSettingStatus: SUCCEEDED, errors: null }; // concat only payload
      
    case getStarted(GET_CHAT_SETTING):
      return { ...state, getChatSettingStatus: STARTED, errors: null };
    case getFailed(GET_CHAT_SETTING):
      return { ...state, getChatSettingStatus: FAILED, errors: getError(payload) };
    case getSucceeded(GET_CHAT_SETTING):
      return { ...state, chatSetting: payload, getChatSettingStatus: SUCCEEDED, errors: null }; // concat only payload 

    case getStarted(UPDATE_CHAT_SETTING):
      return { ...state, updateChatSettingStatus: STARTED, errors: null };
    case getFailed(UPDATE_CHAT_SETTING):
      return { ...state, updateChatSettingStatus: FAILED, errors: getError(payload) };
    case getSucceeded(UPDATE_CHAT_SETTING):
      return { ...state, chatSetting: payload.chatSetting, updateChatSettingStatus: SUCCEEDED, errors: null }; // concat only payload

    default:
      return state;
  }
};

export default events;
